module.exports = __webpack_public_path__ + "img/ic-help.86a32f8b.svg";